let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7mpk7")).then(() => parcelRequire('ksNs6'));